/**
 * SB-3978 B5-T21 (KD-37, Article XXII gap (k)): replaces every anchor under
 * `root` with a `span` holding only the anchor's text, so nothing in the
 * rendered HTML navigates. Returns how many anchors it replaced.
 *
 * An `area` that carries an `href` is treated as an anchor (B2-T32): the
 * `SANITIZE` step keeps a raw-HTML `<area href>`, and nothing else removed it.
 *
 * core-ai already keeps only the links a turn's tools returned; this is the
 * app's own layer behind that filter. It has three users: the live view; the
 * saved reply, but only its inert segment, when marked skips characters in
 * the answer (`inertLinks`, SB-3978 B5-T45); and Copy's HTML in that same
 * case, through `withInertLinks`. Any other saved reply renders as before.
 * A DOM pass after ngx-markdown's render, not a marked
 * renderer, because `marked-instance.guard.spec.ts` refuses any marked
 * extension; and so it also reaches raw-HTML anchors, which the `SANITIZE`
 * step lets through. The text is set with `textContent`, so no markup from
 * inside the anchor survives.
 *
 * One of the two layers core-ai#538's prefix fixture relies on, with
 * `connectorSafeMarkdown`. Any change to either layer, or to a reader or a step before one, re-runs SB-3978 T34's fixture and fuzz (core-ai#538), with no prefix skip.
 */
export const makeLinksInert = (root: ParentNode): number => {
  const anchors = Array.from(root.querySelectorAll('a, area[href]'));
  for (const anchor of anchors) {
    const text = document.createElement('span');
    text.textContent = anchor.textContent;
    anchor.replaceWith(text);
  }
  return anchors.length;
};

/**
 * `html` with every anchor made inert by `makeLinksInert`, for HTML that never
 * reaches the page (Copy's `text/html`, SB-3978 B5-T45). Parsed into a
 * `<template>`, whose content is inert: nothing in it loads or runs.
 */
export const withInertLinks = (html: string): string => {
  const template = document.createElement('template');
  template.innerHTML = html;
  makeLinksInert(template.content);
  return template.innerHTML;
};
